<template>
  <nav
    class="md-layout md-alignment-center-space-between"
    data-test-id="top-toolbar-navigation"
  >
    <div class="block_left">
      <div
        class="nav__logo"
        data-test-id="top-toolbar-logo"
      >
        <logotype/>
      </div>
    </div>

    <div class="block_right">
      <Notifications
        v-if="isLoggedIn"
        @openDialog="openDialog"
        @openLymitDialog="openLymitDialog"
      />

      <LangSwitcher />

      <UserInfo ref="userInfo" />
    </div>

    <AmlDialog
      v-if="activeDialog"
      data-test-id="aml-dialog"
      :active="activeDialog"
      :values="activeDialogData"
      :account="accountId"
      @close="closeDialog"
    />

    <LymitDialog
      v-if="activeLymitDialog"
      data-test-id="lymit-dialog"
      :active="activeLymitDialog"
      :values="activeLymitDialogData"
      :account="accountId"
      @close="closeLymitDialog"
    />
  </nav>
</template>

<script>
  import { vuexTypes } from '@vuex/types'
  import { mapActions, mapGetters } from 'vuex'
  import { commonEvents } from '@js/events/common_events'
  import { attachEventHandler } from '@js/events/helpers'
  import { langByCookie, setLangAskReload } from '@js/i18n'
  import Logotype from '@vue/app/common/Logotype'
  import Notifications from './Notifications.vue'
  import LangSwitcher from './LangSwitcher.vue'
  import UserInfo from './UserInfo.vue'
  import AmlDialog from './AmlDialog.vue'
  import LymitDialog from './LymitDialog.vue'

  export default {
    name: 'root-navbar',

    components: {
      Logotype,
      AmlDialog,
      LymitDialog,
      Notifications,
      LangSwitcher,
      UserInfo
    },

    data: () => ({
      routes: [],
      activeDialog: false,
      activeDialogData: null,
      activeLymitDialog: false,
      activeLymitDialogData: null
    }),

    computed: {
      ...mapGetters({
        isLoggedIn: vuexTypes.isLoggedIn,
        accountId: vuexTypes.accountId,
        getUnreadInc: 'getUnreadInc',
        getUnreadOut: 'getUnreadOut',
        getUnreadLymit: 'getUnreadLymit',
        getUnreadErrorInc: 'getUnreadErrorInc',
        getUnreadErrorOut: 'getUnreadErrorOut',
        getConnectionStatus: 'getConnectionStatus',
        getUserLocale: vuexTypes.getUserLocale
      }),
    },

    watch: {
      isLoggedIn: {
        handler: async function (val) {
          this.closeUserCard()
          if (val) {
            await this.loadLoggedInData()
            await this.getExistMessages()
            if (!this.getConnectionStatus) this.getAMLMessages()
          }
        },
        immediate: true
      },
      $route () {
        this.closeUserCard()
      }
    },

    async created () {
      attachEventHandler(commonEvents.routesUpdateEvent, this.updateRoutes)
    },
    methods: {
      ...mapActions({
          GET_ACCOUNT_KYC_REQUESTS: vuexTypes.GET_ACCOUNT_KYC_REQUESTS,
          GET_UNREAD_MESSAGES: vuexTypes.GET_UNREAD_MESSAGES,
          GET_USER_LOCALE: vuexTypes.GET_USER_LOCALE,
          getAMLMessages: 'getAMLMessages',
          getExistMessages: 'getExistMessages',
      }),
      openDialog ({ id, type }) {
        if (type === 2) {
          this.activeDialogData = this.getUnreadInc.find(el => el.id === id)
        } else if (type === 3) {
          this.activeDialogData = this.getUnreadOut.find(el => el.id === id)
        } else if (type === -1) {
          this.activeDialogData = this.getUnreadErrorInc.find(el => el.id === id)
        } else if (type === -2) {
          this.activeDialogData = this.getUnreadErrorOut.find(el => el.id === id)
        }
        this.activeDialog = true
      },
      closeDialog () {
        this.activeDialog = false
        this.activeDialogData = null
      },
      openLymitDialog (id) {
        this.activeLymitDialogData = this.getUnreadLymit.find(el => el.id === id)
        this.activeLymitDialog = true
      },
      closeLymitDialog () {
        this.activeLymitDialog = false
        this.activeLymitDialogData = null
      },
      updateRoutes (routes) {
        this.routes = routes
      },
      async loadLoggedInData() {
        await this.GET_ACCOUNT_KYC_REQUESTS()
        await this.GET_UNREAD_MESSAGES()
        await this.GET_USER_LOCALE()
        if (langByCookie() !== this.getUserLocale) {
          setLangAskReload(this.getUserLocale)
        }
      },
      closeUserCard () {
        if (this.$refs.userInfo) {
          this.$refs.userInfo.closeUserCard()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../scss/mixins";
  @import "../../scss/variables";

  nav {
    width: 100%;
    flex-wrap: nowrap;
    overflow: hidden;
    @include font('main', $font-size-l, 400);

    @include respond-to(small) {
      position: relative;
    }

    & .block_left {}

    & .block_right {
      display: flex;
      align-items: center;
      gap: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/navigation/Navbar.vue